module.exports = __webpack_public_path__ + "static/Eselhof2-faca0c6ed6714c648a6dfc3d4cfc512a.jpg";